module.exports = __webpack_public_path__ + "static/1-94b56b8b6f00b5b8847c339cd38b0ae5.jpg";